import { render, staticRenderFns } from "./Plumb.vue?vue&type=template&id=c92336c8&"
import script from "./Plumb.vue?vue&type=script&lang=ts&"
export * from "./Plumb.vue?vue&type=script&lang=ts&"
import style0 from "./Plumb.vue?vue&type=style&index=0&id=c92336c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports